import {IComponentOptions} from 'angular';
import {IStateService} from 'angular-ui-router';
import AuthServiceRS from '../../../authentication/service/AuthServiceRS.rest';
import TSUser from '../../../models/TSUser';
import {TSAuthEvent} from '../../../models/enums/TSAuthEvent';
import AuthenticationUtil from '../../utils/AuthenticationUtil';
import IRootScopeService = angular.IRootScopeService;

let template = require('./startView.html');
require('./startView.scss');

export class StartComponentConfig implements IComponentOptions {
    transclude = false;
    template = template;
    controller = StartViewController;
    controllerAs = 'vm';
}

export class StartViewController {

    static $inject: string[] = ['$state', '$rootScope', 'AuthServiceRS'];

    constructor(private $state: IStateService, private $rootScope: IRootScopeService, private authService: AuthServiceRS) {

    }

    $onInit() {
        let user: TSUser | undefined = this.authService.getPrincipal();
        if (user) {  // wenn logged in
            if (user.roles !== undefined) {
                let mostPrivilegedRole = this.authService.getHighestRoleOfBenutzer(user.roles);

                AuthenticationUtil.navigateToStartPageForRole(mostPrivilegedRole, this.$state);
            } else {
                console.warn('User ' + user + ' has no role ');
                this.$rootScope.$broadcast(TSAuthEvent[TSAuthEvent.NOT_AUTHENTICATED], 'no role');
            }
        } else {
            //wenn wir noch nicht eingeloggt sind werden wir das event welches das login prozedere anstoesst
            this.$rootScope.$broadcast(TSAuthEvent[TSAuthEvent.NOT_AUTHENTICATED], 'not logged in on startpage');
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/authentication/component/startView/startView.ts